import React from "react";

export default props => {
  const sizes = props.sizes || ["28oz", "20oz"];
  return (
    <div className={`${props.bottleType}`}>
      <section className="section-heading row">CHOOSE YOUR SIZE</section>
      <section id="sizes" className="row">
        {sizes.map((size, index) => {
          switch (sizes.length) {
            case 1:
              return (
                <div
                  key={`${size}-${index}`}
                  style={{
                    backgroundSize: "contain",
                    backgroundImage: `url(/bottles/${props.type}-${size}-${props.color}.png)`
                  }}
                  onClick={props.selectSize.bind(this, size)}
                  className={`size col-sm-4 col-sm-offset-4 size-${size}`}
                />
              );
            case 2:
              return (
                <div
                  key={`${size}-${index}`}
                  style={{
                    backgroundSize: "contain",
                    backgroundImage: `url(/bottles/${props.type}-${size}-${props.color}.png)`
                  }}
                  onClick={props.selectSize.bind(this, size)}
                  className={`size col-sm-4 ${index === 1 &&
                    "col-sm-offset-4"} size-${size}`}
                />
              );
            case 3:
              return (
                <div
                  key={`${size}-${index}`}
                  style={{
                    backgroundSize: "contain",
                    backgroundImage: `url(/bottles/${props.type}-${size}-${props.color}.png)`
                  }}
                  onClick={props.selectSize.bind(this, size)}
                  className={`size col-sm-4 size-${size}`}
                />
              );
            case 4:
              return (
                <div
                  key={`${size}-${index}`}
                  style={{
                    backgroundSize: "contain",
                    backgroundImage: `url(/bottles/${props.type}-${size}-${props.color}.png)`
                  }}
                  onClick={props.selectSize.bind(this, size)}
                  className={`size col-sm-3 size-${size}`}
                />
              );
            default:
              return <div key={`${size}-${index}`} />;
          }
        })}
      </section>
      <section className="row bottle-labels">
        {sizes.map((size, index) => {
          let returnVal;
          switch (sizes.length) {
            case 1:
              returnVal = (
                <div
                  className={`text-center size-label col-sm-4 col-sm-offset-4 size-${size}`}
                >
                  {size}
                </div>
              );
              break;
            case 2:
              returnVal = (
                <div
                  className={`text-center size-label col-sm-4 ${index === 1 &&
                    "col-sm-offset-4"} size-${size}`}
                >
                  {size}
                </div>
              );
              break;
            case 3:
              returnVal = (
                <div className={`text-center size-label col-sm-4 size-${size}`}>
                  {size}
                </div>
              );
              break;
            case 4:
              returnVal = (
                <div className={`text-center size-label col-sm-3 size-${size}`}>
                  {size}
                </div>
              );
              break;
            default:
              returnVal = <div />;
              break;
          }
          return returnVal;
        })}
      </section>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/ChooseSize.jsx